export default "__VITE_ASSET__BLiP0USw__"